// Vue
import { Vue, Component, Prop, Inject } from "vue-property-decorator";

// Template
import template from "./template.vue";

// Base Module
import ModuleBase from "#/common/ModuleBase";

// Components
import { Observer } from "mobx-vue";

@Observer
@Component({
  mixins: [template],
  components: {},
})
export class PopularSolutionModule extends ModuleBase {
  getBackgroundColorFromInstance(instance: object): string {
    return "black";
  }
}
